import { AccessTime, VerifiedUser } from "@mui/icons-material";
import { Box, Typography, alpha, useTheme } from "@mui/material";
import { useState } from "react";

interface ExpandableStatusChipProps {
  signed: boolean;
}

export function ExpandableStatusChip({ signed }: ExpandableStatusChipProps) {
  const theme = useTheme();
  const [expanded, setExpanded] = useState(false);
  const label = signed ? "Assinado" : "Pendente";
  const Icon = signed ? VerifiedUser : AccessTime;
  const mainColor = signed
    ? theme.palette.success.main
    : theme.palette.warning.dark;

  return (
    <Box
      component="button"
      type="button"
      onClick={(e) => {
        e.stopPropagation();
        setExpanded((prev) => !prev);
      }}
      aria-label={label}
      aria-expanded={expanded}
      title={expanded ? undefined : label}
      sx={{
        display: "inline-flex",
        alignItems: "center",
        height: 26,
        borderRadius: 13,
        border: "1px solid",
        borderColor: alpha(mainColor, 0.35),
        bgcolor: alpha(mainColor, signed ? 0.1 : 0.08),
        color: mainColor,
        cursor: "pointer",
        overflow: "hidden",
        pl: 0.6,
        pr: expanded ? 1.25 : 0.6,
        gap: expanded ? 0.5 : 0,
        transition:
          "padding 0.22s ease, gap 0.22s ease, background-color 0.15s ease",
        flexShrink: 0,
        "&:hover": {
          bgcolor: alpha(mainColor, 0.16),
        },
      }}
    >
      <Icon sx={{ fontSize: 15, flexShrink: 0 }} />
      <Typography
        component="span"
        sx={{
          fontSize: "0.7rem",
          fontWeight: 600,
          lineHeight: 1,
          whiteSpace: "nowrap",
          width: expanded ? "auto" : 0,
          opacity: expanded ? 1 : 0,
          overflow: "hidden",
          transition: "width 0.22s ease, opacity 0.18s ease",
        }}
      >
        {label}
      </Typography>
    </Box>
  );
}
